// The colour vocabulary shared by the planning components (timeline board, tray, month
// calendar, stat tiles). Each tone maps to the --tms-plan-* variables in styles/_planning.scss,
// which carry light and dark values - so a screen chooses a MEANING, never a colour.
export enum PlanningTone {
  neutral = 'neutral',
  success = 'success',
  danger = 'danger',
  info = 'info',
  warning = 'warning',
  accent = 'accent',
  muted = 'muted',
}
